module.exports = __webpack_public_path__ + "img/logo.808df396.svg";